// extracted by mini-css-extract-plugin
export default {"cont":"UserSummary_cont__2BkmP","det":"UserSummary_det__FTRun","name":"UserSummary_name__Mm-zL","email":"UserSummary_email__CMZ-3"};